// extracted by css-extract-rspack-plugin
module.exports =  {"container":"Symbols-eM6z__container","visible-symbols-container":"Symbols-uBAs__visible-symbols-container","more-buttons-button":"Symbols-caDy__more-buttons-button"};